var rtlMapping = {
  left: 'right',
  right: 'left'
};

var getPointerStyles = function getPointerStyles(pointerOffset, pointerGap, pointerMargin, rtl, popperPlacement, isSvg) {
  var placementValue = (popperPlacement || '').split('-', 1).pop();
  var placement = rtl && rtlMapping[placementValue] || placementValue;
  var rootStyles = {
    top: {
      marginBottom: pointerMargin
    },
    right: {
      marginLeft: pointerMargin
    },
    bottom: {
      marginTop: pointerMargin
    },
    left: {
      marginRight: pointerMargin
    }
  };
  var pointerStyles = {
    top: {
      bottom: "-".concat(pointerOffset),
      marginLeft: pointerGap,
      marginRight: pointerGap,
      transform: isSvg ? "rotate(".concat(rtl ? 90 : -90, "deg)") : 'rotate(45deg)'
    },
    right: {
      left: "-".concat(pointerOffset),
      marginBottom: pointerGap,
      marginTop: pointerGap,
      transform: isSvg ? "rotate(".concat(rtl ? 180 : 0, "deg)") : 'rotate(135deg)'
    },
    bottom: {
      top: "-".concat(pointerOffset),
      marginLeft: pointerGap,
      marginRight: pointerGap,
      transform: isSvg ? "rotate(".concat(rtl ? -90 : 90, "deg)") : 'rotate(-135deg)'
    },
    left: {
      right: "-".concat(pointerOffset),
      marginBottom: pointerGap,
      marginTop: pointerGap,
      transform: isSvg ? "rotate(".concat(rtl ? 0 : 180, "deg)") : 'rotate(-45deg)'
    }
  };
  return {
    root: rootStyles[placement],
    pointer: pointerStyles[placement]
  };
};

export default getPointerStyles;